<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog
        v-model="dialog"
        max-width="600px"
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>add_circle_outline</v-icon>
        </v-btn>
        <v-card>
          <v-toolbar
            card
            dense
            color="transparent"
          >

            <v-btn
              icon
              @click.native="close"
            >
              <v-icon>reply</v-icon>
            </v-btn>

            <!-- <v-toolbar-title><h4>Details</h4></v-toolbar-title> -->
            <v-btn
              icon
              @click.native="saveAndClose"
            >
              <v-icon>library_add</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="save"
            >
              <v-icon>save</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="add"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="deleterow"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="first"
            >
              <v-icon>first_page</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="next"
            >
              <v-icon>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="previous"
            >
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="last"
            >
              <v-icon>last_page</v-icon>
            </v-btn>
            <v-menu
              bottom
              left
            >
              <v-btn
                slot="activator"
                icon
              >
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in items"
                  :key="i"
                  click
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <!-- <v-spacer></v-spacer> <v-btn color="primary" outline>Post</v-btn> -->
          </v-toolbar>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form
              v-model="editedItem.valid"
              ref="form"
              lazy-validation
            >
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex
                    xs8
                    sm8
                  >
                    <v-text-field
                      v-model="editedItem.name"
                      label="Name"
                      :rules="editedItem.requiredfield"
                      required
                      prepend-icon="select_all"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs4
                    sm4
                  >
                    <v-text-field
                      v-model="editedItem.tarWeight"
                      label="Tar Weight"
                      :rules="editedItem.requiredfield"
                      required
                      suffix="KG"
                      type="number"
                      prepend-icon="play_for_work"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-textarea
                      v-model="editedItem.description"
                      label="Description"
                      prepend-icon="description"
                    >
                    </v-textarea>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md4
                  >
                    <v-autocomplete
                      label="Status"
                      prepend-icon="notes"
                      v-model="editedItem.statusCodeID"
                      :items="statusOptions"
                    >
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>

          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" outline @click.native="close">Cancel</v-btn>
            <v-btn color="primary darken-1" outline @click.native="save">Save</v-btn>
          </v-card-actions> -->
          <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog>

        </v-card>
      </v-dialog>
    </v-toolbar>
    <app-section-loader :status="loader"></app-section-loader>
    <v-data-table
      :headers="headers"
      :items="gridItems"
      :search="search"
      class="elevation-1"
      default-sort="plasticBagId:desc"
    >
      <template
        slot="items"
        slot-scope="props"
      >

        <td>{{ props.item.name }}</td>
        <td>{{ props.item.tarWeight }}</td>
        <td class="text-xs-left">{{ props.item.description }}</td>
        <td class="text-xs-left">{{ props.item.addedByUser }}</td>
        <td class="text-xs-left">{{ props.item.modifiedByUser }}</td>
        <td class="text-xs-left">{{ props.item.modifiedDate | formatDate}}</td>

        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="onDeleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn
          color="primary"
          outline
          @click="initialize"
        > Record not exist.Refresh again in while time.</v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      :top="y === 'top'"
      :timeout="timeout"
      v-model="snackbar"
    >
      {{ snackbarMessage }}
    </v-snackbar>
    <delete-confirmation-dialog
      ref="deleteConfirmationDialog"
      heading="Are You Sure You Want To Delete?"
      message="Are You Sure You Want To Delete This Item Permanently?"
      @onConfirm="deleteItem"
    >
    </delete-confirmation-dialog>
  </div>
</template>
<script>
import { getPlasticBags, getPlasticBag, createPlasticBag, updatePlasticBag, deletePlasticBag } from '@/api/plasticbag';
import GlobalMessage from '@/constant'
export default {
  components: {

  },
  data: () => ({
    dialog: false,
    loader: false,
    search: '',
    statusOptions: [
      { text: 'Active', value: 1 },
      { text: 'InActive', value: 2 }
    ],
    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    y: 'top',
    headers: [
      { text: 'Name', value: 'name', align: 'left' },
      { text: 'Tae Weight(KG)', value: 'name', align: 'left' },
      { text: 'Description', value: 'description', align: 'left' },
      { text: 'Added By', value: 'Added', align: 'left' },
      { text: 'Modified By', value: 'Modifiedby', align: 'left' },
      { text: 'Modified Date', value: 'ModifiedDate', align: 'left' },
      { text: 'Actions', value: 'name', sortable: false, align: 'left' }
    ],
    gridItems: [],
    dropItems: [],
    editedIndex: -1,
    selectedItem: null,
    editedItem: {
      valid: false,
      plasticBagID: -1,
      name: '',
      tarWeight: 0,
      nameRules: [v => !!v || 'Name is required'],
      description: '',
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date()
    },
    defaultItem: {
      valid: false,
      PlasticBagID: -1,
      name: '',
      requiredfield: [v => !!v || 'This is required field'],
      description: '',
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date()
    },
    searchItem: { action: '', Id: null, searchString: 'searchString', },
    items: [
      { title: 'Clear Items' },
      { title: 'Post' },
      { title: 'Delete' },
      { title: 'Print' }
    ],
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add Plastic Bag' : 'Edit Plastic Bag';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.loader = true;
      getPlasticBags('')
        .then(response => {
          this.gridItems = response.data;
          this.loader = false;
          console.log(this.gridItems);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });


    },
    editItem (item) {
      this.editedIndex = this.gridItems.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.selectedItem = item;
    },
    deleteItem () {
      this.$refs.deleteConfirmationDialog.close();
      this.loader = true;
      let index = this.gridItems.indexOf(this.selectedItem);
      deletePlasticBag(this.selectedItem)
        .then(() => {
          this.loader = false;
          this.selectedItem = null;
          this.gridItems.splice(index, 1);
         window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          this.loader = false;
         window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    saveAndClose () {
      this.save();
      this.close();
    },
    toolfunction () {

      getPlasticBag(this.searchItem)
        .then(response => {

          if (response.data.plasticBagID != null) {

            this.editedItem = response.data;
            let index = this.gridItems.map(item => item.plasticBagID).indexOf(response.data.plasticBagID)
            this.editedIndex = index;

          }
          else {
           window.getApp.$emit('APP_API_SUCCESS', 'No more record to view');
          }

        })
        .catch(error => {
          // this.loader = false;
         window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    first () {
      this.searchItem.action = 'First';
      this.searchItem.Id = this.editedItem.plasticBagID;
      // this.selectedItem.searchString = 'first';
      this.toolfunction();
    },
    last () {
      this.searchItem.action = 'Last';
      this.searchItem.Id = this.editedItem.plasticBagID;
      //this.selectedItem.searchString = 'last';

      this.toolfunction();
    },
    previous () {
      this.searchItem.action = 'Previous';
      this.searchItem.Id = this.editedItem.plasticBagID;
      //this.selectedItem.searchString = 'previous';
      this.toolfunction();
    },
    next () {
      this.searchItem.action = 'Next';
      this.searchItem.Id = this.editedItem.plasticBagID;
      // this.selectedItem.searchString = 'next';
      this.toolfunction();
    },
    add () {

      this.editedItem.valid = false;
      this.editedItem.plasticBagID = -1;
      this.editedItem.name = '';
      this.editedItem.nameRules = [v => !!v || 'Name is required'];
      this.editedItem.description = '';
      this.editedItem.addedByUserID = this.$store.state.auth.userId;
      this.editedItem.addedDate = new Date();
      this.editedItem.statusCodeID = 1;
      this.editedItem.statusCode = 'Active';
      this.editedItem.modifiedByUserID = this.$store.state.auth.userId;
      this.editedItem.modifiedDate = new Date();
      this.editedIndex = -1;
    },
    deleterow () {
      this.$refs.formdeleteConfirmationDialog.openDialog();
    },
    formDeleteItem () {
      this.$refs.formdeleteConfirmationDialog.close();
      // this.loader = true;
      let index = this.editedIndex;

      deletePlasticBag(this.editedItem.plasticBagID)
        .then(() => {
          //this.loader = false;
          //this.editedItem = null;
          this.add();
          this.gridItems.splice(index, 1);
         window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          //this.loader = false;
         window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      this.initialize();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save () {
      if (this.$refs.form.validate()) {
        this.loader = true;
        let index = this.editedIndex;
        if (this.editedIndex > -1) {
          Object.assign(this.gridItems[this.editedIndex], this.editedItem);
          this.editedItem.modifiedByUserID = this.$store.state.auth.userId;
          this.editedItem.modifiedDate = new Date();
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          updatePlasticBag(this.editedItem)
            .then(response => {
              Object.assign(this.gridItems[index], response.data);
              this.loader = false;
             window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          this.editedItem.plasticBagID = parseInt(Math.random() * 100) + 1024; // mock a id
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          this.editedItem.statusCodeID = 1;
          createPlasticBag(this.editedItem)
            .then(response => {
              this.gridItems.push(response.data);
              this.loader = false;
             
              this.editedItem = response.data;
              let index = this.gridItems.map(item => item.plasticBagID).indexOf(response.data.plasticBagID)
              this.editedIndex = index;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
        //this.close();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/masters/PlasticBag.vue